import type * as UpdateDeliveryChannel from '@ori-events/update-delivery-channel';
import type {
  Data as ErrorData,
  UpdateDeliveryChannelResponse,
} from '@ori-events/update-delivery-channel-failed';
import {
  isUpdateDeliveryChannelErrorResponse,
  Name as ErrorEventName,
} from '@ori-events/update-delivery-channel-failed';

import { convertToCamelCase } from '../helpers';
import { RequestUrl } from '../models';
import { putRequestOptions } from '~/constants';

type Data = UpdateDeliveryChannel.Data;

export default async ({ detail: { deliveryChannelId } }: CustomEvent<Data>) => {
  const requestOptions = {
    ...putRequestOptions,
    body: JSON.stringify({ deliveryChannelId }),
  };
  const request = await fetch(RequestUrl.UpdateDeliveryChannel, requestOptions);

  const response = convertToCamelCase<UpdateDeliveryChannelResponse>(
    (await request.json()) as object,
  );

  if (isUpdateDeliveryChannelErrorResponse(response)) {
    const errorEvent = new CustomEvent<ErrorData>(ErrorEventName, {
      detail: response,
    });
    window.dispatchEvent(errorEvent);

    return false;
  }

  return response;
};
